import { render } from "./SyaratKetentuanItem.vue?vue&type=template&id=4e10bb67"
import script from "./SyaratKetentuanItem.vue?vue&type=script&lang=js"
export * from "./SyaratKetentuanItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__